module.exports = __webpack_public_path__ + "static/Youth-ba1ce9a10bb449e9aa901b5353add0ee.png";